import angular from 'angular'
import { TranscludeComponent } from '../transclude.component';
import { CollapsibleSidebarShellComponent } from './collapsible-sidebar-shell.component';

export const CollapsibleSidebarModule = angular
    .module("apex.common.collapsibleSidebar", [])
    .component("apexCollapsibleSidebarShell", CollapsibleSidebarShellComponent)
    .component("apexSidebarContent", TranscludeComponent)
    .component("apexBodyContent", TranscludeComponent)
    .name
